import { Navigate } from "react-router-dom"

const BillingSettings = () => {
  return <Navigate to="/settings/plan" replace />
}

export default BillingSettings
